import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
}), 'Equalizer');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Equalizer.js
// module id = 3378
// module chunks = 2